"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AwsMarketplaceService = void 0;
const request_1 = require("../core/request");
class AwsMarketplaceService {
    /**
     * 验证AWS Marketplace注册Token
     * 验证AWS Marketplace提供的注册Token，获取客户信息并创建或更新订阅信息。
     * 该接口会：
     * 1. 验证Token并获取客户信息
     * 2. 验证空间是否存在
     * 3. 创建或更新订阅信息
     *
     * @param requestBody
     * @returns any Token验证成功，返回空间ID和订阅状态
     * @throws ApiError
     */
    static async verifyToken(requestBody) {
        const result = await (0, request_1.request)({
            method: 'POST',
            path: `/api/aws/marketplace/verify-token`,
            body: requestBody,
        });
        return result.body;
    }
}
exports.AwsMarketplaceService = AwsMarketplaceService;
